import {  useParams } from "react-router-dom";
import { useGetCustomerByIdQuery } from "./customerApi";
import React, { FormEvent, useEffect, useMemo, useState } from "react";
import Breadcrumb from "../../components/common/Breadcrumbs";
import SettingTab from "./setting/SettingTab";
import { hasPermission } from "../../helpers/utils/AccessControlUtils";
import { Tabs } from "react-simple-tabs-component";
import { fetchWithExtraOptions, tgxApi } from "../../app/tgxApi";
import CustomerAutoHoa from "./customerAutoHoa/customerAutoHoa";
import Integrations from "./integrations/integrations";


const CustomerDetailPage = () => {
    const { customerId } = useParams();
    const [crumbs, setCrumbs] = useState<any[]>([]);


    // @ts-ignore
    fetchWithExtraOptions(tgxApi.endpoints.getCustomerById, { customerId }, {
        redirectToErrorPage: true,
        skip: !customerId
    });

    const customerQuery = useGetCustomerByIdQuery(customerId);

    useEffect(() => {
        const customerObj = customerQuery?.data;
        if (customerObj) {
            setCrumbs([
                { content: "Home", url: "/home" },
                { content: "Customers", url: "/customers" },
                { content: customerObj?.customerName, url: "" }
            ]);

            document.title = `${customerObj?.customerName}`;
        }
    }, [customerQuery?.data]);

    // Compute tabs using useMemo
    const bottomTabs = useMemo(() => {
        const result: any[] = [];
        if (hasPermission(["BRAN-V"])) {
            result.push({
                label: 'Settings',
                Component: SettingTab
            });
        }

        if (hasPermission(["BRAN-V"])) {
            result.push({
                label: 'Integrations',
                Component: Integrations
            });
        }
        if (hasPermission(["BRAN-V"])) {
            result.push({
                label: 'Customer Auto HOA',
                Component: CustomerAutoHoa
            });
        }

        return result;
    }, []);


    return (
        <div className="px-4 py-2">
            <div className="justify-between sm:block md:flex lg:flex">
                <Breadcrumb crumbs={crumbs} />
            </div>


            <Tabs tabs={bottomTabs} className="bootstrap-tabs-component mt-3" />
        </div>
    );
}

export default CustomerDetailPage;
